import _Array$from from 'babel-runtime/core-js/array/from';

import { crmFileSaveAPI, crmFileDeleteAPI } from '@/api/common';
import { filePathToBlob } from '@/utils';

export default {
  name: 'DetailImg',
  components: {},
  props: {
    detail: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      primaryList: [],
      detailList: [],
      type: 'main',
      loading: false
    };
  },

  watch: {
    detail: {
      handler: function handler(data) {
        if (data) {
          this.primaryList = data.mainFile || [];
          this.detailList = data.detailFile || [];
        }
      },

      immediate: true
    }
  },
  mounted: function mounted() {},

  methods: {
    upLoadImg: function upLoadImg(type) {
      this.type = type;
      if (type === 'main') {
        this.$refs.primaryImgInput.click();
      } else {
        this.$refs.detailImgInput.click();
      }
    },


    /**
     * 处理选择的图片
     */
    selectImg: function selectImg(url) {
      var _this = this;

      filePathToBlob(url).then(function (blob) {
        var type = url.split('.').slice(-1) || 'png';
        var name = url.split('/').slice(-1);
        var file = new File([blob], name, { type: 'image/' + type });
        var even = {
          target: {
            files: [file]
          }
        };
        _this.upLoad(even);
      });
    },


    /**
     * 上传
     */
    upLoad: function upLoad(event) {
      var _this2 = this;

      var files = _Array$from(event.target.files);
      if (this.type === 'main' && files.length + this.primaryList.length > 9) {
        files = files.slice(0, 9 - this.primaryList.length);
        this.$message.error('最多只能上传9张图片');
      } else if (files.length + this.detailList.length > 9) {
        files = files.slice(0, 9 - this.detailList.length);
        this.$message.error('最多只能上传9张图片');
      }

      for (var index = 0; index < files.length; index++) {
        var file = files[index];
        this.loading = true;
        crmFileSaveAPI({
          type: 'img',
          file: file
        }).then(function (res) {
          var data = res.data || {};
          if (_this2.type === 'main') {
            _this2.primaryList.push(data);
            _this2.loading = false;
            _this2.$emit('change', 'mainFile', _this2.primaryList);
          } else {
            _this2.detailList.push(data);
            _this2.loading = false;
            _this2.$emit('change', 'detailFile', _this2.detailList);
          }
        }).catch(function () {
          _this2.loading = false;
        });
      }
    },


    /**
     * 删除图片
     */
    deleteImg: function deleteImg(type, index) {
      var _this3 = this;

      var params = {};
      if (type == 'main') {
        params.file_id = this.primaryList[index].file_id;
        params.save_name = this.primaryList[index].save_name;
      } else {
        params.file_id = this.detailList[index].file_id;
        params.save_name = this.detailList[index].save_name;
      }
      this.$confirm('此操作将永久删除该图片, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.loading = true;
        crmFileDeleteAPI(params).then(function (res) {
          _this3.$message.success('删除成功');
          if (type == 'main') {
            _this3.primaryList.splice(index, 1);
            _this3.$emit('change', 'mainFile', _this3.primaryList);
            _this3.$emit('delete', 'mainFile', _this3.primaryList);
          } else {
            _this3.detailList.splice(index, 1);
            _this3.$emit('change', 'detailFile', _this3.detailList);
            _this3.$emit('delete', 'detailFile', _this3.detailList);
          }
          _this3.loading = false;
        }).catch(function () {
          _this3.loading = false;
        });
      }).catch(function () {});
    },


    /**
     * 预览图片
     */
    previewImage: function previewImage(list, index) {
      this.$bus.emit('preview-image-bus', {
        index: index,
        data: list.map(function (item) {
          item.url = item.path;
          return item;
        })
      });
    }
  }
};